import React, { useState } from 'react'
import styled from 'styled-components'
import { Box, Button, Flex, Heading, OpenNewIcon, PrizeIcon, Text, Link } from '@pancakeswap/uikit'
import useWeb3Provider from 'hooks/useActiveWeb3React'
import { useTranslation } from 'contexts/Localization'
import { Team } from 'config/constants/types'
import SighHelper from 'components/SighHelper'

import { ToastDescriptionWithTx } from 'components/Toast'
import { fetchNonce } from 'state/deblox/igo/helpers'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { useWeb3React } from '@web3-react/core'
import useApproveConfirmTransaction from 'hooks/useApproveConfirmTransaction'
import { signMessage } from 'utils/web3React'
import useToast from 'hooks/useToast'
import ConnectWalletButton from 'components/ConnectWalletButton'
import ApproveAndConfirmStage from 'views/GameDetail/components/ApproveAndConfirmStage'

interface TeamCardProps {
  type: string
  name: string
  logo: string
  url?: string
  btnText?: string
  description?: string
  url2?: string
  description2?: string
}

const FlexBody = styled(Flex)`
  align-items: center;
  flex: 1;
  padding: 24px 32px;
  margin: 20px 0;
  position: relative;

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: row;
    font-size: 40px;
    min-height: 158px;
    margin: 0;
  }

  .community-item {
    width: 100%;
    &.discord-item {
      ${({ theme }) => theme.mediaQueries.lg} {
        width: 230px;
      }
    }
  }
`
const SecondBox = styled(Box)`
  width: 100%;
  margin-top: 20px;
  ${({ theme }) => theme.mediaQueries.lg} {
    margin-left: 156px;
    margin-top: 0;
    width: auto;
  }
`

const Avatar = styled.img`
  width: 36px;
  margin-right: 18px;
  ${({ theme }) => theme.mediaQueries.lg} {
    width: 52px;
    margin-right: 24px;
  }
`

const StyledTeamCard = styled(Box)`
  background: #222A3D;
  border-radius: 13px;
`

const StyledLink = styled(Link)`
  width: 100%;
  text-decoration: none;
  ${({ theme }) => theme.mediaQueries.lg} {
    margin-top: 9px;
  }

  &:hover {
    text-decoration: none;
  }
`
const LinkStyle = styled(Link)`
  display: block;
  width: 100%;
  &:hover {
    text-decoration: none;
  }
`
const CopyImgStyle = styled.img`
  width: 20px;
  cursor: pointer;
  position: absolute;
  top: 136px;
  right: calc(5% + 6px);
  ${({ theme }) => theme.mediaQueries.lg} {
    top: 73px;
    right: 28px;
  }
`
const SighHelperStyle = styled(SighHelper)`
  position: absolute;
  top: 112px;
  right: calc(5% + 6px);
  ${({ theme }) => theme.mediaQueries.lg} {
    top: 48px;
    right: 28px;
  }
`
const NewButton  = styled(Button)`
  font-size: 12px;
  height: 40px;
  border-radius: 10px;
  width: 90%;
  ${({ theme }) => theme.mediaQueries.lg} {
    font-size: 13px;
    width: 210px;
  }
  & > div {
    height: 36px;
    background: #0C1733;
    border-radius: 10px;
    padding: 0;
  }
`
const Description = styled(Box)`
  font-size: 14px;
  color: #6F6E6E;
  margin-top: 6px;
  padding-left: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 16px;
  white-space: nowrap;
  ${({ theme }) => theme.mediaQueries.lg} {
    margin-top: 12px;
  }
`
const OpenNewIconStyle = styled(OpenNewIcon)`
  vertical-align: middle;
  margin-top: -2px;
`
const Message = styled(Box)`
  font-size: 14px;
  color: #6F6E6E;
  word-break: break-all;
  padding-left: 2px;
`
const ConnectWalletButtonStyle = styled(ConnectWalletButton)`
  font-size: 14px;
  height: 40px;
  border-radius: 10px;
  width: 100%;
  max-width: 230px;
  ${({ theme }) => theme.mediaQueries.lg} {
    margin-bottom: 0;
  }
  & > div {
    height: 36px;
    background: #0C1733;
    border-radius: 10px;
    margin: 0 !important;
  }
`

export enum BuyingStage {
  REVIEW,
  APPROVE_AND_CONFIRM,
  CONFIRM,
  TX_CONFIRMED,
}

const DISCORD_DEBLOX_IO_INVITE = process.env.DISCORD_DEBLOX_IO_INVITE || "https://discord.gg/GcVu3Ekkmd"

const Signature = () => {
  const [stage, setStage] = useState(BuyingStage.REVIEW)
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { library } = useWeb3Provider()
  const [signedMessage, setSignedMessage] = useState('')
  const [copied, setCopied] = useState(false)

  const { toastSuccess, toastError } = useToast()

  const handleConfirmVote = async () => {
    const data = await fetchNonce(account, "1")
    console.log('-----unsigned message', account, data)
    const correlationId = data.correlationId
    const unsignedMessage = data.nonce

    setStage(BuyingStage.APPROVE_AND_CONFIRM)
    await signMessage(library, account, unsignedMessage)
      .then(res => {
        setSignedMessage(`${correlationId}, ${res}`)
        setStage(BuyingStage.TX_CONFIRMED)
      })
      .catch(() => {
        setStage(BuyingStage.REVIEW)
      })
  }

  const { isApproving, isApproved, isConfirming, onConfirm } = useApproveConfirmTransaction({
    onRequiresApproval: async () => {
      return false
    },
    onApprove: () => {
      return null
    },
    onApproveSuccess: async ({ receipt }) => {
      toastSuccess(
        t('Contract approved'),
        <ToastDescriptionWithTx txHash={receipt.transactionHash} />,
      )
    },
    onConfirm: () => {
      return null
    },
    onSuccess: async ({ receipt }) => {
      setStage(BuyingStage.TX_CONFIRMED)
      toastSuccess(
        t('Signature received'),
        <ToastDescriptionWithTx txHash={receipt.transactionHash} />,
      )
    },
  })

  const handleConfirm = async () => {
    try {
      const tx = await onConfirm()
      const receipt = await tx.wait()
      if (receipt.status) {
        setStage(BuyingStage.TX_CONFIRMED)
      }
    } catch (error) {
      setStage(BuyingStage.REVIEW)
    }
  }

  const showCopiedMessage = content => {
    setCopied(true)
    toastSuccess(t('Copy Success!'))
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <>
    {stage === BuyingStage.REVIEW && 
      (
        <NewButton onClick={handleConfirmVote}> {t('Sign in Wallet')} </NewButton>
      )}
    {stage === BuyingStage.APPROVE_AND_CONFIRM && (
        <NewButton disabled> {t('Signing')} </NewButton>
    )}
    {
    stage === BuyingStage.TX_CONFIRMED &&
      (
        <Box>
          {
            signedMessage ? (
              <>
                <SighHelperStyle mr="4px" placement="top-start"
                  text={
                    (
                      <Box className="qr-title">
                        <Message>
                          <div>{t('Copy text and send to Deblox bot ')}</div>
                          <div>{t('to join premium group:')}</div>
                          <div>{signedMessage}</div>
                        </Message>
                      </Box>
                    )
                  }
                />

                {
                  copied
                  ?
                  <CopyImgStyle alt="" src="/images/copy-success.png" />
                  :
                  <CopyToClipboard text={ signedMessage } onCopy={() => showCopiedMessage(signedMessage)}>
                    <CopyImgStyle alt="Click to copy this address" src="/images/copy.png" />
                  </CopyToClipboard>
                }
                <StyledLink href={DISCORD_DEBLOX_IO_INVITE} external>
                  <NewButton>
                    {t('Open Discord')}
                    <OpenNewIconStyle color="#fff" ml="4px" />
                  </NewButton>
                </StyledLink>
              </>
            ) : (
              <NewButton disabled>
                {t('Signing')}
              </NewButton>
            )
          }
        </Box>
      )
    }
      </>
  )
}

const TeamCard: React.FC<TeamCardProps> = ({ url, btnText, type, logo, description2, description }) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  return (
    <StyledTeamCard>
      <FlexBody>
        <Avatar src={`${logo}`} alt="team avatar" />
        <Flex flexWrap="wrap" flex={1} overflow="hidden" alignItems="center">
          <Box className={type === 'discord' ? 'community-item discord-item' : 'community-item'}>
            <LinkStyle mt="8px" external href={url}><NewButton>{btnText}<OpenNewIconStyle color="#fff" ml="4px" /></NewButton></LinkStyle>
            <Description title={description}>{description}</Description>
          </Box>
          
          {
            type === 'discord' && (
              <SecondBox className={type === 'discord' ? 'community-item discord-item' : 'community-item'}>
                {
                  account ? (
                    <Box>
                      <Signature />
                      <Description title={description2}>{description2}</Description>
                    </Box>
                  ) : (
                    <Box>
                      <ConnectWalletButtonStyle />
                      <Description title={description2}>{description2}</Description>
                    </Box>
                  )
                }
              </SecondBox>
            )
          }
        </Flex>
      </FlexBody>
    </StyledTeamCard>
  )
}

export default TeamCard
